import { createTheme as createMuiTheme } from './theme';
var lightTheme;
var darkTheme;
var createTheme = function (type) {
    if (type === 'light') {
        return (lightTheme = lightTheme || createMuiTheme({ palette: { type: 'light' } }));
    }
    return (darkTheme = darkTheme || createMuiTheme({ palette: { type: 'dark' } }));
};
export var getTheme = function (themeType) {
    if (typeof themeType === 'string') {
        return createTheme(themeType);
    }
    return themeType;
};
export var getColor = function (colorString, themeType) {
    var theme = getTheme(themeType);
    var colorArr = colorString.split('.');
    var color = colorArr[0];
    var palette = theme.palette[color];
    if (typeof palette === 'object') {
        var variant = colorArr[1];
        var paletteVariant = palette[variant];
        if (typeof paletteVariant === 'string') {
            return paletteVariant;
        }
    }
    if (process.env.NODE_ENV === 'test') {
        return "Color ".concat(colorString, " not found.");
    }
    throw Error("Color ".concat(colorString, " not found."));
};
//# sourceMappingURL=themeHelpers.js.map